import { Component, forwardRef, Input, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderFilePickerModel } from '../page-builder-file-picker.model';

@Component({
    selector: 'abw-page-builder-file-picker-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PageBuilderFilePickerFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PageBuilderFilePickerFormComponent),
        multi: true
      }
    ],
    templateUrl: './page-builder-file-picker-form.component.html',
    styleUrls: ['./page-builder-file-picker-form.component.scss']
})
export class PageBuilderFilePickerFormComponent implements ControlValueAccessor {
    @Input() model: PageBuilderFilePickerModel;
    @Input() value: string;

    constructor(private cdf: ChangeDetectorRef) {}

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onFileChanged(event: any) {
      var reader = new FileReader();
      reader.onload = () => {
        this.value = reader.result + "";
        this.propagateChange(this.value);
        this.cdf.detectChanges();
      };
      reader.readAsDataURL(event.target.files[0]);
  }
}